/**
 * Cria uma função que constrói e reutiliza uma única instância sob demanda.
 *
 * @param factory - Função que cria a instância na primeira chamada.
 * @returns Função que retorna sempre a mesma instância memorizada.
 *
 * @example
 * const getInserter = createLazySingleton(() => createInserter("taskpane"));
 */
export function createLazySingleton<T>(factory: () => T): () => T {
  let instance: T | null = null;
  return () => {
    if (!instance) {
      instance = factory();
    }
    return instance;
  };
}
